import React from "react";
import PropTypes from "prop-types";
import { Segment, Item, Icon } from "semantic-ui-react";
import { ItemData, Paginate } from "../../components";
import Link from "next/link";

import {
  get_converted_value,
  getOrdinalSuffix,
  customdecodeURIComponent,
} from "../../common/Utils";

const CitiesList = ({
  itemData,
  href,
  prev,
  active,
  header,
  getData,
  cat,
  selectedtab,
  display,
  onClick,
  customclass,
  handleHover,
  handleCityUnHover,
  personalizationdata,
  handleCityClick,
  heart,
  save,
  displaydatasummary,
  onsummaryClick,
  isEnabled,
  handleCityfulllistClick,
  ...props
}) => {
  let page_size = 3;
  let indexdata = (active - 1) * page_size;
  let finaldata = [];
  let postal_city_arr = [];
  let npi_duplicate_name = [];
  let additional_txt = "";
  let additional_value = "";
  let sort_value = "npisore";
  itemData &&
    itemData.length > 0 &&
    itemData.map((item, index) => {
      if (
        item.postalcity_name !== "" &&
        postal_city_arr.includes(item.postalcity_name) === false
      ) {
        postal_city_arr.push(item.postalcity_name);
        finaldata.push(item);
        npi_duplicate_name.push({
          id: index,
          postal_name: item.postalcity_name,
          npi: item.npi,
          value: item.value,
        });
      }
      npi_duplicate_name.map((item1, index1) => {
        if (
          item1.postal_name !== "" &&
          item.postalcity_name !== "" &&
          item1.postal_name === item.postalcity_name
        ) {
          if (item1.id !== index) {
            item1.npi = item1.npi + "," + item.npi;
            item1.value = item1.value + "," + item.value;
          }
        }
      });
      let personalNpi = "-";
      if (item.cityaverage && item.cityaverage.length > 0) {
        item.additional_txt = "";
        item.additional_value = "";
        /*Personal Score Calculation Start */
        if (personalizationdata && personalizationdata.length > 0) {
          let schoolsdata = personalizationdata[0].schoolScore;
          let safetydata = personalizationdata[0].crimeRate;
          let walkabilitydata = personalizationdata[0].walkability;
          let publicspacesdata = personalizationdata[0].publicspaces;
          let curbAppealdata = personalizationdata[0].curbAppeal;
          let valueindexdata = personalizationdata[0].valueIndex;
          // let minpricedata = prsonaldata.pricemin;
          // let maxpricedata = prsonaldata.pricemax;

          var sumOfWeights = 0;

          if (item.cityaverage[0].schoolscore > 0) {
            sumOfWeights += Number(schoolsdata);
          }
          if (item.cityaverage[0].crimescore > 0) {
            sumOfWeights += Number(safetydata);
          }
          if (item.cityaverage[0].walkscore > 0) {
            sumOfWeights += Number(walkabilitydata);
          }
          if (item.cityaverage[0].comscore > 0) {
            sumOfWeights += Number(publicspacesdata);
          }
          if (item.cityaverage[0].crubscore > 0) {
            sumOfWeights += Number(curbAppealdata);
          }

          var targetFactorWeights = {
            schools: schoolsdata / sumOfWeights,
            safety: safetydata / sumOfWeights,
            walkability: walkabilitydata / sumOfWeights,
            publicspaces: publicspacesdata / sumOfWeights,
            curbAppeal: curbAppealdata / sumOfWeights,
            elementarySchool: 0,
            middleSchool: 0,
            highSchool: 0,
            neighborhoodValueIndexs: valueindexdata / sumOfWeights,
          };

          var targetRadiusFromSearchLocations = 0; // in miles
          var targetSearchLocationLats;
          var targetSearchLocationLongs;
          var targetMinPrices = 0;
          var targetMaxPrices = 0;

          const minPriceAdjustments = 0.85;
          const maxPriceAdjustments = 1.15;
          const minRadiuss = 5.0; // in miles
          const bayAreaNeighborhoodMinimumMedianPrices = 500000.0; // benchmarked to median home price for Antioch
          const maxNviScaleFactors = 0.096;
          if (targetRadiusFromSearchLocations < minRadiuss) {
            targetRadiusFromSearchLocations = minRadiuss;
          }
          targetMinPrices *= minPriceAdjustments;
          targetMaxPrices *= maxPriceAdjustments;

          targetFactorWeights["neighborhoodValueIndexs"] =
            personalizationdata[0].valueIndex / sumOfWeights;

          targetFactorWeights["schools"] =
            personalizationdata[0].schoolScore / sumOfWeights;

          // Copy school weight into elementarySchool, middleSchool, highSchool
          targetFactorWeights["elementarySchool"] =
            targetFactorWeights["schools"];
          targetFactorWeights["middleSchool"] = targetFactorWeights["schools"];
          targetFactorWeights["highSchool"] = targetFactorWeights["schools"];

          // let neighborhoodValueIndexs = get_converted_value()
          //   parseFloat(item.cityaverage[0].valuescore) / 10;
          let neighborhoodValueIndexs = get_converted_value(
            parseFloat(item.cityaverage[0].valuescore),
          );

          personalNpi = Math.round(
            parseFloat(
              item.cityaverage[0].schoolscore * targetFactorWeights["schools"] +
                item.cityaverage[0].comscore *
                  targetFactorWeights["publicspaces"] +
                item.cityaverage[0].crimescore * targetFactorWeights["safety"] +
                item.cityaverage[0].crubscore *
                  targetFactorWeights["curbAppeal"] +
                item.cityaverage[0].walkscore *
                  targetFactorWeights["walkability"],
            ) * 10,
          );
        }
        /*Personal Score Calculation Warp */

        if (selectedtab === 0) {
          item.sort_value = Math.round(item.cityaverage[0].npiscore_city);
          item.personalscore = "-";
        }
        if (selectedtab === 1) {
          item.additional_txt = "Personal";
          item.additional_value = Number(
            ((personalNpi / 100) * 5).toFixed(2),
          ).toFixed(1);
          item.sort_value = Math.round(personalNpi);
          item.personalscore = Number(
            ((personalNpi / 100) * 5).toFixed(2),
          ).toFixed(1);
        }
        if (
          selectedtab === 2 ||
          selectedtab === 9 ||
          selectedtab === 10 ||
          selectedtab === 11
        ) {
          item.additional_txt = "School";
          item.additional_value = Number(
            ((item.cityaverage[0].schoolscore / 10) * 5).toFixed(2),
          ).toFixed(1);

          item.sort_value = Math.round(item.cityaverage[0].schoolscore_city);
          item.personalscore = "-";
        }

        if (selectedtab === 3) {
          item.additional_txt = "Safety";
          item.additional_value = Number(
            ((item.cityaverage[0].crimescore / 10) * 5).toFixed(2),
          ).toFixed(1);

          item.sort_value = Math.round(item.cityaverage[0].crimescore_city);
          item.personalscore = "-";
        }

        if (selectedtab === 4 || selectedtab === 16) {
          item.additional_txt = "Amenities";
          item.additional_value = "-";
          item.sort_value = Math.round(0);
          item.personalscore = "-";
        }

        if (selectedtab === 5 || selectedtab === 18) {
          item.additional_txt = "Price";
          item.additional_value = Math.round(
            (item.cityaverage[0].medianpricescore / 10) * 5,
          );
          item.sort_value = Math.round(
            item.cityaverage[0].medianpricescore_city,
          );
          item.personalscore = "-";
        }

        if (selectedtab === 6) {
          // item.additional_txt = "Appreciation";
          // item.additional_value = Math.round(
          //   (item.cityaverage[0].crubscore / 10) * 5
          // );
          // item.sort_value = Math.round(item.cityaverage[0].crubscore);
          // item.personalscore = "-";
        }

        if (selectedtab === 7) {
          item.additional_txt = "Appreciation";
          item.additional_value = Math.round(
            (item.cityaverage[0].crubscore / 10) * 5,
          );
          item.sort_value = Math.round(item.cityaverage[0].appreciation_city);
          item.personalscore = "-";
        }
        if (selectedtab === 20) {
          //item.additional_txt = "Value";
          // item.additional_value = Math.round(
          //   (item.cityaverage[0].valuescore / 10) * 5
          // );
          item.sort_value = Math.round(item.cityaverage[0].valuescore_city);
          item.personalscore = "-";
        }
        if (selectedtab === 8) {
          // item.additional_txt = "Personal";
          // item.additional_value = (personalNpi / 100) * 5;
          // item.sort_value = Math.round(personalNpi);
          // item.personalscore = (personalNpi / 100) * 5;
        }
        if (selectedtab === 12) {
          item.additional_txt = "Near Merchants";
          item.additional_value = Number(
            ((item.cityaverage[0].walkscore / 10) * 5).toFixed(2),
          ).toFixed(1);

          item.sort_value = Math.round(item.cityaverage[0].walkscore);
          item.personalscore = "-";
        }
        if (selectedtab === 13) {
          item.additional_txt = "Public Spaces";
          item.additional_value = Number(
            ((item.cityaverage[0].comscore / 10) * 5).toFixed(2),
          ).toFixed(1);

          item.sort_value = Math.round(item.cityaverage[0].comscore);
        }
        if (selectedtab === 14) {
          item.additional_txt = "Walkable Street";
          item.additional_value = Number(
            ((item.cityaverage[0].otherscore / 10) * 5).toFixed(2),
          ).toFixed(1);

          item.sort_value = Math.round(item.cityaverage[0].otherscore);
        }
        if (selectedtab === 15) {
          item.additional_txt = "Curb Appeal";
          item.additional_value = Number(
            ((item.cityaverage[0].crubscore / 10) * 5).toFixed(2),
          ).toFixed(1);

          item.sort_value = Math.round(item.cityaverage[0].crubscore);
        }
      } else {
        item.additional_txt = "";
        item.additional_value = "";
        /*Personal Score Calculation Start */
        if (personalizationdata && personalizationdata.length > 0) {
          let schoolsdata = personalizationdata[0].schoolScore;
          let safetydata = personalizationdata[0].crimeRate;
          let walkabilitydata = personalizationdata[0].walkability;
          let publicspacesdata = personalizationdata[0].publicspaces;
          let curbAppealdata = personalizationdata[0].curbAppeal;
          let valueindexdata = personalizationdata[0].valueIndex;
          // let minpricedata = prsonaldata.pricemin;
          // let maxpricedata = prsonaldata.pricemax;

          var sumOfWeights =
            Number(schoolsdata) +
            Number(safetydata) +
            Number(walkabilitydata) +
            Number(publicspacesdata) +
            Number(curbAppealdata);

          var targetFactorWeights = {
            schools: schoolsdata / sumOfWeights,
            safety: safetydata / sumOfWeights,
            walkability: walkabilitydata / sumOfWeights,
            publicspaces: publicspacesdata / sumOfWeights,
            curbAppeal: curbAppealdata / sumOfWeights,
            elementarySchool: 0,
            middleSchool: 0,
            highSchool: 0,
            neighborhoodValueIndexs: valueindexdata / sumOfWeights,
          };

          var targetRadiusFromSearchLocations = 0; // in miles
          var targetSearchLocationLats;
          var targetSearchLocationLongs;
          var targetMinPrices = 0;
          var targetMaxPrices = 0;

          const minPriceAdjustments = 0.85;
          const maxPriceAdjustments = 1.15;
          const minRadiuss = 5.0; // in miles
          const bayAreaNeighborhoodMinimumMedianPrices = 500000.0; // benchmarked to median home price for Antioch
          const maxNviScaleFactors = 0.096;
          if (targetRadiusFromSearchLocations < minRadiuss) {
            targetRadiusFromSearchLocations = minRadiuss;
          }
          targetMinPrices *= minPriceAdjustments;
          targetMaxPrices *= maxPriceAdjustments;

          targetFactorWeights["neighborhoodValueIndexs"] =
            personalizationdata[0].valueIndex / sumOfWeights;

          targetFactorWeights["schools"] =
            personalizationdata[0].schoolScore / sumOfWeights;

          // Copy school weight into elementarySchool, middleSchool, highSchool
          targetFactorWeights["elementarySchool"] =
            targetFactorWeights["schools"];
          targetFactorWeights["middleSchool"] = targetFactorWeights["schools"];
          targetFactorWeights["highSchool"] = targetFactorWeights["schools"];

          //let neighborhoodValueIndexs = parseFloat(item.valuescore_city) / 10;
          let neighborhoodValueIndexs = get_converted_value(
            parseFloat(item.valuescore_city),
          );

          personalNpi = Math.round(
            parseFloat(
              item.schoolscore_city * targetFactorWeights["schools"] +
                0 * targetFactorWeights["publicspaces"] +
                item.crimescore_city * targetFactorWeights["safety"] +
                0 * targetFactorWeights["curbAppeal"] +
                item.walkscore_city * targetFactorWeights["walkability"],
            ) * 10,
          );
        }
        /*Personal Score Calculation Warp */

        if (selectedtab === 0) {
          item.sort_value = Math.round(item.npiscore_city);
          item.personalscore = "-";
        }
        if (selectedtab === 20) {
          //item.additional_txt = "Value";
          // item.additional_value = Number(
          //   ((item.valuescore_city / 100) * 5).toFixed(2)
          // ).toFixed(1);
          item.sort_value = Math.round(item.valuescore_city);
          item.personalscore = "-";
        }
        if (selectedtab === 1) {
          item.additional_txt = "Personal";
          item.additional_value = Number(
            ((personalNpi / 100) * 5).toFixed(2),
          ).toFixed(1);
          item.sort_value = Math.round(personalNpi);
          item.personalscore = Number(
            ((personalNpi / 100) * 5).toFixed(2),
          ).toFixed(1);
        }
        if (selectedtab === 2 || selectedtab === 8) {
          item.additional_txt = "School";

          item.additional_value = Number(
            ((item.schoolscore_city / 10) * 5).toFixed(2),
          ).toFixed(1);
          item.sort_value = Math.round(item.schoolscore_city);
          item.personalscore = "-";
        }
        if (selectedtab === 9) {
          item.additional_txt = "Elementary School";

          item.additional_value = Number(
            ((item.primaryschoolscore_city / 10) * 5).toFixed(2),
          ).toFixed(1);
          item.sort_value = Math.round(item.primaryschoolscore_city);
          item.personalscore = "-";
        }
        if (selectedtab === 10) {
          item.additional_txt = "Middle School";

          item.additional_value = Number(
            ((item.middleschoolscore_city / 10) * 5).toFixed(2),
          ).toFixed(1);
          item.sort_value = Math.round(item.middleschoolscore_city);
          item.personalscore = "-";
        }
        if (selectedtab === 11) {
          item.additional_txt = "High School";

          item.additional_value = Number(
            ((item.highschoolscore_city / 10) * 5).toFixed(2),
          ).toFixed(1);
          item.sort_value = Math.round(item.highschoolscore_city);
          item.personalscore = "-";
        }

        if (selectedtab === 3) {
          item.additional_txt = "Safety";

          item.additional_value = Number(
            ((item.crimescore_city / 10) * 5).toFixed(2),
          ).toFixed(1);
          item.sort_value = Math.round(item.crimescore_city);
          item.personalscore = "-";
        }

        if (selectedtab === 4 || selectedtab === 16) {
          item.additional_txt = "Amenities";
          item.additional_value = "-";
          item.sort_value = Math.round(0);
          item.personalscore = "-";
        }

        if (selectedtab === 5 || selectedtab === 18) {
          item.additional_txt = "Price";
          if (item.medianpricescore_city !== 0) {
            item.additional_value = "$" + item.medianpricescore_city;
            item.sort_value = item.medianpricescore_city;
          } else {
            item.additional_value = "-";
            item.sort_value = 0;
          }
          item.personalscore = "-";
        }

        if (selectedtab === 6) {
          // item.additional_txt = "Appreciation";
          // item.additional_value = "-";
          // item.sort_value = Math.round(0);
          // item.personalscore = "-";
        }

        if (selectedtab === 7) {
          item.additional_txt = "Appreciation";
          item.additional_value = "-";
          item.sort_value = Math.round(0);
          item.personalscore = "-";
        }
        if (selectedtab === 12) {
          item.additional_txt = "Near Merchants";
          item.additional_value = Number(
            ((item.walkscore_city / 10) * 5).toFixed(2),
          ).toFixed(1);
          item.sort_value = Math.round(item.walkscore_city);
          item.personalscore = "-";
        }
        if (selectedtab === 13) {
          item.additional_txt = "Public Spaces";
          item.additional_value = "-";
          item.sort_value = Math.round(0);
          item.personalscore = "-";
        }
        if (selectedtab === 14) {
          item.additional_txt = "Walkable Street";
          item.additional_value = "-";
          item.sort_value = Math.round(0);
          item.personalscore = "-";
        }
        if (selectedtab === 15) {
          item.additional_txt = "Curb Appeal";
          item.additional_value = "-";
          item.sort_value = Math.round(0);
          item.personalscore = "-";
        }
      }
    });

  finaldata.sort((a, b) => {
    let fa = parseInt(a.sort_value),
      fb = parseInt(b.sort_value);

    if (fa < fb) {
      return 1;
    }
    if (fa > fb) {
      return -1;
    }
    return 0;
  });

  const newArray =
    finaldata &&
    finaldata.length > 0 &&
    finaldata.map((obj, index) => ({ ...obj, number: index + 1 }));

  // finaldata.map((item, index) => {
  //   npi_duplicate_name.map((item1, index1) => {
  //     if (item1.postal_name === item.postalcity_name) {
  //npi
  //       if (item1.npi) {
  //         var avg = item1.npi.split(",");
  //         const nuevo = avg.map(i => Number(i));

  // var final_npi = sum_avg / avg_len;
  //         item.npi = (nuevo.reduce((a, b) => a + b, 0) / nuevo.length).toFixed(
  //           2
  //         );
  //       } else {
  //         item.npi = 0;
  //       }
  //       if (item1.value) {
  //value index
  //         var avg_val = item1.value.split(",");
  //         const nuevoval = avg_val.map(i => Number(i));
  // var avg_len_val = avg_val.length;
  // var sum_avg_val = 0;
  // avg_val.map((item2, index2) => {
  //   sum_avg_val = parseFloat(sum_avg_val) + parseFloat(item2);
  // });
  // var final_value = sum_avg_val / avg_len_val;
  //         item.value = (
  //           nuevoval.reduce((a, b) => a + b, 0) / nuevoval.length
  //         ).toFixed(2);
  //       } else {
  //         item.value = 0;
  //       }
  //     }
  //   });
  // });
  function sliceWithSpaces(final_summary, additional_txt) {
    let textWithoutSpaces = final_summary.replace(/\s+/g, "");

    let sliceLength = additional_txt ? 90 : 120;
    let slicedWithoutSpaces = textWithoutSpaces.slice(0, sliceLength);
    let displayedText = "";
    let index = 0;

    for (let i = 0; i < final_summary.length; i++) {
      displayedText += final_summary[i];
      if (index < slicedWithoutSpaces.length && final_summary[i] !== " ") {
        index++;
      }
      if (index >= slicedWithoutSpaces.length) {
        break;
      }
    }
    return displayedText;
  }

  return (
    <Segment basic style={{ paddingLeft: 0, marginTop: 0 }}>
      <div style={{ paddingLeft: 0 }}>
        {newArray && newArray.length === 0 && (
          <div>
            <p style={{ color: "rgba(0,0,0,.87)" }}>
              {cat === "top" ? "No Result Found." : "No saved cities."}
            </p>
          </div>
        )}
        {newArray && newArray.length !== 0 && (
          <Item.Group>
            {newArray
              .slice(indexdata)
              .slice(0, page_size)
              .map((item, index) => {
                let final_summary = "";
                if (item.reviewSummary && item.reviewSummary !== null) {
                  final_summary = customdecodeURIComponent(item.reviewSummary);
                }
                let final_summary_index = "summary_" + item.id + index;
                let final_index = item.id + index + cat;
                let cityimages = "";
                if (item.cityimage && item.cityimage !== null) {
                  cityimages = item.cityimage;
                }
                let npisore = "";
                let valuescore = "";
                let personalscore = "";
                let schoolscore = "";
                let crimescore = "";
                let walkscore = "";
                if (item.cityaverage && item.cityaverage.length > 0) {
                  npisore = Number(
                    ((item.cityaverage[0].npisore / 100) * 5).toFixed(2),
                  ).toFixed(1);
                  valuescore = Number(
                    ((item.cityaverage[0].valuescore / 100) * 5).toFixed(2),
                  ).toFixed(1);
                  personalscore = item.personalscore;
                  schoolscore = Number(
                    ((item.cityaverage[0].schoolscore / 10) * 5).toFixed(2),
                  ).toFixed(1);
                  crimescore = Number(
                    ((item.cityaverage[0].crimescore / 10) * 5).toFixed(2),
                  ).toFixed(1);
                  walkscore = Number(
                    ((item.cityaverage[0].walkscore / 10) * 5).toFixed(2),
                  ).toFixed(1);
                } else {
                  npisore = Number(
                    ((item.npiscore_city / 100) * 5).toFixed(2),
                  ).toFixed(1);
                  valuescore = Number(
                    ((item.valuescore_city / 100) * 5).toFixed(2),
                  ).toFixed(1);
                  personalscore = item.personalscore;

                  schoolscore = Number(
                    ((item.schoolscore_city / 10) * 5).toFixed(2),
                  ).toFixed(1);
                  crimescore = Number(
                    ((item.crimescore_city / 10) * 5).toFixed(2),
                  ).toFixed(1);
                  walkscore = Number(
                    ((item.walkscore_city / 10) * 5).toFixed(2),
                  ).toFixed(1);
                }

                return (
                  <Item
                    key={(Date.now() + item.npi + index).toString()}
                    style={{ position: "relative" }}
                    onMouseLeave={() => handleCityUnHover()}
                    className="nhlist_items"
                  >
                    <div className="nh_ranking_list_mb">
                      <div style={{ marginTop: 0 }}>
                        <div className="nh_ranking_rating">
                          {item.number}
                          <sup className="nh_ranking_suffix">
                            {getOrdinalSuffix(item.number)}
                          </sup>
                        </div>
                      </div>

                      {cityimages != "" ? (
                        <a
                          style={{
                            cursor: "pointer",
                            marginRight: 20,
                            marginLeft: 5,
                          }}
                          target="_blank"
                          onMouseEnter={() =>
                            handleHover(item.postalcity_name, item.state_name)
                          }
                          href={`/City/${item.cityfullname}`}
                          // onClick={() =>
                          //   handleCityClick(
                          //     item.postalcity_name,
                          //     item.state_name,
                          //     item.cityfullname
                          //   )
                          // }
                          // ondbClick={() =>
                          //   handleCitydbClick(`/City/${item.cityfullname}`)
                          // }
                          title={item.postalcity_name}
                        >
                          <Item.Image
                            className="nhpannel_img"
                            src={cityimages}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src =
                                process.env.NEXT_PUBLIC_CDN_ID +
                                "static/images/defaultcitymap.jpg";
                            }}
                          />
                          <div
                            style={{
                              position: "absolute",
                              top: 0,
                              width: "100%",
                              height: "auto",
                            }}
                          >
                            <>
                              {heart && heart[item.postalcity_name] ? (
                                <span
                                  onClick={(e) => {
                                    save(item.postalcity_name, item, "select");
                                    e.preventDefault();
                                  }}
                                  //onMouseLeave={() => handleCityUnHover()}
                                >
                                  <Icon
                                    size="big"
                                    name="heart"
                                    //color="#c02e26"
                                    style={{
                                      color: "#c02e26",
                                      position: "absolute",
                                      top: "10px",
                                      left: "175px",
                                      fontSize: "18px",
                                      cursor: "pointer",
                                    }}
                                  />
                                </span>
                              ) : (
                                <span
                                  onClick={(e) => {
                                    save(item.postalcity_name, item, "select");
                                    e.preventDefault();
                                  }}
                                  onMouseEnter={() =>
                                    handleHover(
                                      item.postalcity_name,
                                      item.state_name,
                                    )
                                  }
                                  //  onMouseLeave={() => handleCityUnHover()}
                                >
                                  <Icon
                                    size="big"
                                    name="heart outline"
                                    style={{
                                      color: "white",
                                      position: "absolute",
                                      top: "10px",
                                      left: "175px",
                                      fontSize: "18px",
                                      cursor: "pointer",
                                    }}
                                  />
                                </span>
                              )}
                            </>
                          </div>
                        </a>
                      ) : (
                        <a
                          style={{
                            cursor: "pointer",
                            marginRight: 20,
                            marginLeft: 5,
                          }}
                          target="_blank"
                          onMouseEnter={() =>
                            handleHover(item.postalcity_name, item.state_name)
                          }
                          href={`/City/${item.cityfullname}`}
                          //onMouseLeave={() => handleCityUnHover()}
                          // onClick={() =>
                          //   handleCityClick(
                          //     item.postalcity_name,
                          //     item.state_name,
                          //     item.cityfullname
                          //   )
                          // }
                          // onClick={() =>
                          //   handleCitydbClick(`/City/${item.cityfullname}`)
                          // }
                          title={item.postalcity_name}
                        >
                          <Item.Image
                            className="nhpannel_img"
                            src={`${process.env.NEXT_PUBLIC_CDN_ID}static/images/defaultcitymap.jpg`}
                          />
                          <div
                            style={{
                              position: "absolute",
                              top: 0,
                              width: "100%",
                              height: "auto",
                            }}
                          >
                            <>
                              {heart && heart[item.postalcity_name] ? (
                                <span
                                  onClick={(e) => {
                                    save(item.postalcity_name, item, "select");
                                    e.preventDefault();
                                  }}
                                  //onMouseLeave={() => handleCityUnHover()}
                                >
                                  <Icon
                                    size="big"
                                    name="heart"
                                    //color="#c02e26"
                                    style={{
                                      color: "#c02e26",
                                      position: "absolute",
                                      top: "8px",
                                      left: "175px",
                                      fontSize: "18px",
                                      cursor: "pointer",
                                    }}
                                  />
                                </span>
                              ) : (
                                <span
                                  onClick={(e) => {
                                    save(item.postalcity_name, item, "select");
                                    e.preventDefault();
                                  }}
                                  onMouseEnter={() =>
                                    handleHover(
                                      item.postalcity_name,
                                      item.state_name,
                                    )
                                  }
                                  //  onMouseLeave={() => handleCityUnHover()}
                                >
                                  <Icon
                                    size="big"
                                    name="heart outline"
                                    style={{
                                      color: "white",
                                      position: "absolute",
                                      top: "8px",
                                      left: "2px",
                                      fontSize: "18px",
                                      cursor: "pointer",
                                    }}
                                  />
                                </span>
                              )}
                            </>
                          </div>
                        </a>
                      )}
                    </div>
                    {/* <a style={{marginRight:20}} target="_blank"><Item.Image className="nhpannel_img" src='/static/images/defaultadd.jpg' style={{cursor:'pointer'}} /></a> */}

                    <Item.Content className="right_content_top">
                      {display[final_index] ? (
                        <>
                          {" "}
                          <Icon
                            name="minus circle"
                            size="small"
                            onClick={(e) => onClick(e, final_index, cat)}
                          />{" "}
                        </>
                      ) : (
                        <>
                          {" "}
                          <Icon
                            className="plus_icon_city"
                            name="plus circle"
                            size="small"
                            onClick={(e) => onClick(e, final_index, cat)}
                          />{" "}
                        </>
                      )}
                      <div
                      // href={
                      //   "/City/?name=" +
                      //   item.postalcity_name +
                      //   "&state=" +
                      //   item.state_name
                      // }
                      >
                        <a
                          target="_blank"
                          onMouseEnter={() =>
                            handleHover(item.postalcity_name, item.state_name)
                          }
                          href={`/City/${item.cityfullname}`}
                          //onMouseLeave={() => handleCityUnHover()}
                          // onClick={() =>
                          //   handleCityClick(
                          //     item.postalcity_name,
                          //     item.state_name,
                          //     item.cityfullname
                          //   )
                          // }
                          // onClick={() =>
                          //   handleCitydbClick(`/City/${item.cityfullname}`)
                          // }
                          title={item.postalcity_name}
                        >
                          <Item.Header className="nhpannel_head">
                            {item.postalcity_name}
                          </Item.Header>
                        </a>
                      </div>
                      <Item.Description className="nh_desc_city">
                        {display[final_index] ? (
                          <>
                            <p className="nhpannel_npi">Overall: {npisore}</p>
                            <p className="nhpannel_npi">
                              Value Index: {valuescore}
                            </p>
                            {cat === "recome" && (
                              <p className="nhpannel_npi">
                                Personal:{" "}
                                {personalscore != "" && personalscore != "-"
                                  ? personalscore
                                  : "-"}
                              </p>
                            )}
                            <p className="nhpannel_npi">School:{schoolscore}</p>
                            <p className="nhpannel_npi">Safety:{crimescore}</p>
                            <p className="nhpannel_npi">Amenities:{"-"}</p>
                            <p className="nhpannel_npi">Near Merchants:{"-"}</p>
                            <p className="nhpannel_npi">Public Spaces: -</p>
                            {/* <p className="nhpannel_npi">Walkable Street: -</p> */}
                            <p className="nhpannel_npi">Curb Appeal: -</p>
                            <p className="nhpannel_npi">
                              Personal:
                              {personalscore != "" && personalscore != "-"
                                ? personalscore
                                : "-"}
                            </p>
                          </>
                        ) : (
                          <>
                            <p className="nhpannel_npi">Overall: {npisore}</p>
                            {/* <p
                              className={
                                item.additional_txt || cat === "recome"
                                  ? "nhpannel_npi"
                                  : "nhpannel_value"
                              }
                            >
                              Value Index:{valuescore}
                            </p> */}
                            {cat === "recome" && (
                              <p className="nhpannel_npi">
                                Personal:
                                {personalscore != "" && personalscore != "-"
                                  ? personalscore
                                  : "-"}
                              </p>
                            )}

                            {item.additional_txt &&
                            item.additional_txt !== "" ? (
                              <p className="nhpannel_value">
                                {item.additional_txt}: {item.additional_value}
                              </p>
                            ) : (
                              <p
                                className="nhpannel_value"
                                style={{
                                  marginTop:
                                    display[final_index] || cat === "recome"
                                      ? "0px"
                                      : "0px",
                                }}
                              ></p>
                            )}
                          </>
                        )}
                        {displaydatasummary &&
                        displaydatasummary[final_summary_index] ? (
                          <>
                            <p className="nhpannel_desc nhdesc">
                              {final_summary}
                              <span
                                className="summarylessmore"
                                onClick={(e) =>
                                  onsummaryClick(e, final_summary_index)
                                }
                              >
                                {" "}
                                ..Less
                              </span>
                            </p>
                          </>
                        ) : (
                          <>
                            {final_summary != "" ? (
                              <>
                                {final_summary.length > 50 ? (
                                  <p
                                    className={`nhpannel_desc nhdesc ${
                                      item.additional_txt === "Value"
                                        ? "three-lines"
                                        : item.additional_txt
                                          ? "four-lines"
                                          : "four-lines"
                                    }`}
                                  >
                                    {sliceWithSpaces(
                                      final_summary,
                                      item.additional_txt,
                                    )}
                                    <span
                                      className="summarylessmore"
                                      onClick={(e) =>
                                        onsummaryClick(e, final_summary_index)
                                      }
                                    >
                                      {" "}
                                      ...
                                    </span>
                                  </p>
                                ) : (
                                  <p className="nhpannel_desc nhdesc">
                                    {final_summary}
                                  </p>
                                )}
                              </>
                            ) : (
                              <p className="nhpannel_desc nhdesc">
                                {/* Best park in the peninsula.Most wonderful
                                      neighbours. */}
                              </p>
                            )}
                          </>
                        )}

                        {/* <p className="nhpannel_desc">
                          Best park in the peninsula.Most wonderful neighbours.
                        </p> */}
                      </Item.Description>
                    </Item.Content>
                  </Item>
                );
              })}
          </Item.Group>
        )}
        {finaldata.length > 3 && (
          <Paginate
            length={finaldata.length}
            prev={prev}
            active={active}
            isEnabled={isEnabled}
            seefulllist={() => handleCityfulllistClick()}
            {...props}
          />
        )}
      </div>
    </Segment>
  );
};

CitiesList.propTypes = {
  itemData: PropTypes.array.isRequired,
};

export default CitiesList;
